import { useTranslation } from 'react-i18next'

import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../constants/request'
import { useNotification } from '../../../../../hooks'
import {
  DocumentFolderFormModal,
  getDocumentFolderFormErrorNotification,
  getDocumentFolderFormSuccessNotification,
} from '../../../../Document'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'

export function useRequestProfileCreateFolderAction() {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const {
    handleCloseModal,
    handleReloadAfterChange,
    outboundUuid,
    requestData,
    setModal,
  } = useRequestProfileContext()

  function handleFolderError() {
    handleAddErrorNotification(getDocumentFolderFormErrorNotification(t))
  }

  function handleFolderSuccess(data) {
    handleCloseModal()
    handleAddSuccessNotification(
      getDocumentFolderFormSuccessNotification(data, { t })
    )
    handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.documents)
  }

  function handleClickCreateFolder() {
    setModal(
      <DocumentFolderFormModal
        outboundUuid={outboundUuid}
        parent={requestData?.directory_id?.toString()}
        onClose={handleCloseModal}
        onError={handleFolderError}
        onSuccess={handleFolderSuccess}
      />
    )
  }

  return { handleClickCreateFolder }
}
